<template>
  <div class="jin-m-details jin-m">
    <SelectHeadM title="岗位申请" />
    <Common />
  </div>
</template>

<script>
import Common from './common'
export default {
  components: {
    Common
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.jin {
  /deep/ &-post {
    &-tip {
      line-height: 22px;
      margin-bottom: 18px;
      display: none;
    }

    &-head {
      padding: 0 18px;
      background: linear-gradient(180deg, #f3f9fe 0%, #fff 100%);

      &-warp {
        padding: 22px 0;
        border-bottom: 1px solid #e8e8ea;
      }

      &-title {
        h3 {
          font-size: 18px;
          line-height: 25px;

          &::before {
            padding-right: 2px;
            width: 18px;
            height: 18px;
          }
        }

        span {
          font-size: 14px;
          line-height: 20px;
        }
      }

      &-info {
        p {
          font-size: 11px;
          color: #a0a4b7;
          line-height: 15px;
          margin-top: 7px;
        }
      }
    }
  }

  /deep/ &-details {
    &-body {
      padding: 22px 18px 0;

      &-warp {
        border-bottom: none;
      }

      .date {
        font-size: 11px;
        line-height: 15px;
      }

      &-item {
        margin-top: 12px;
        border-top: 1px solid #e8e8ea;
        padding-top: 6px;

        &:nth-child(1) {
          border: none;
        }

        p {
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 9px;
        }

        ul {
          li {
            p {
              font-size: 11px;
              line-height: 24px;
            }
          }
        }
      }
    }

    &-footer {
      padding: 18px 22px 45px;

      .share,
      .submit {
        height: 40px;
        border-radius: 20px;
        font-size: 13px;
        font-weight: 500;
      }

      .share {
        width: 104px;
        margin-right: 9px;
      }

      .submit {
        width: 100%;
      }
    }
  }
}
</style>
